export const projectWorkContactsEnUS = {
  workContacts: 'Work Contacts',
}

export const projectWorkContactsEsMX = {
  workContacts: 'Contactos de trabajo',
}
